import { FaGraduationCap } from "react-icons/fa";
import { HiMenu, HiX } from "react-icons/hi";
import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import LogoImg from "../../assets/LogoCBT.png";

const menuItems = [
  { label: "Home", href: "#home" },
  { label: "Features", href: "#features" },
  { label: "Questions", href: "#questions" },
  { label: "About", href: "#desktopapp" },
  { label: "Contact", href: "#contact" },
];

const Navbar = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const handleLogin = () => {
    navigate("/login");
  };

  // Scroll
  const [activeSection, setActiveSection] = useState("home");
  useEffect(() => {
    const handleScroll = () => {
      // Determine which section is currently in view
      const sections = menuItems.map((item) => item.href.substring(1));
      const scrollPosition = window.scrollY + 100; // Adding offset for navbar height

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;

          if (
            scrollPosition >= offsetTop &&
            scrollPosition < offsetTop + offsetHeight
          ) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSmoothScroll = (e: any, href: any) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      setActiveSection(href.substring(1));
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      setIsMobileMenuOpen(false);
    }
  };
  const ultraSmooth = {
    type: "spring",
    stiffness: 80,
    damping: 20,
    mass: 0.5,
  };

  return (
    <motion.div
      animate={{ height: isMobileMenuOpen ? "auto" : "auto" }}
      transition={ultraSmooth}
      className="fixed top-2 md:top-5 left-1/2 -translate-x-1/2 w-[95%] md:w-[90%] max-w-7xl bg-white/60 backdrop-blur-md rounded-3xl shadow-inner px-6 py-3 border border-gray-200 z-[999] overflow-hidden"
    >
      {/* Top bar */}
      <div className="flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center space-x-2">
          <div className="w-full h-[40px]  overflow-hidden flex items-center justify-center">
            <img
              src={LogoImg}
              alt="Logo"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center justify-center flex-1 space-x-8">
          {menuItems.map((item) => {
            const sectionId = item.href.substring(1);
            return (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => handleSmoothScroll(e, item.href)}
                className={`text-sm font-medium transition ${
                  activeSection === sectionId
                    ? "text-blue-700 font-semibold "
                    : "hover:text-blue-700 text-gray-700"
                }`}
              >
                {item.label}
              </a>
            );
          })}
        </nav>

        {/* Desktop Button */}
        {/* <div className="hidden md:flex space-x-2">
                    <motion.button
                        onClick={handleLogin}
                        whileTap={{ scale: 0.95 }}
                        className="px-4 py-1.5 text-sm bg-gray-800 text-white rounded-full hover:bg-gray-700 transition"
                    >
                        Get Started
                    </motion.button>
                </div> */}

        {/* Mobile Toggle Button */}
        <div className="md:hidden flex items-center h-full">
          <button
            onClick={() => setIsMobileMenuOpen((prev) => !prev)}
            className="text-gray-800 flex items-center justify-center h-full"
          >
            {isMobileMenuOpen ? <HiX size={24} /> : <HiMenu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu inside the navbar */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.nav
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="md:hidden mt-4 flex flex-col space-y-3 items-center"
          >
            {menuItems.map((item) => {
              const sectionId = item.href.substring(1);
              return (
                <a
                  key={item.label}
                  href={item.href}
                  className={`text-sm font-medium transition ${
                    activeSection === sectionId
                      ? "text-blue-700 font-semibold "
                      : "hover:text-blue-700 text-gray-700"
                  }`}
                  onClick={(e) => handleSmoothScroll(e, item.href)}
                >
                  {item.label}
                </a>
              );
            })}
            <motion.button
              onClick={handleLogin}
              whileTap={{ scale: 0.95 }}
              className="mt-2 px-4 py-2 w-full text-sm bg-gray-800 text-white rounded-full hover:bg-gray-700 transition"
            >
              Get Started
            </motion.button>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default Navbar;
